import {
  doc,
  onSnapshot,
  deleteDoc,
  type Unsubscribe,
  type DocumentReference,
  type DocumentSnapshot,
  type Firestore,
} from 'firebase/firestore'
import { type ChatStreamDocument, type ChatStreamStatusValue } from '@hapana/shared/schemas/support'

const CHAT_STREAMS_COLLECTION = 'chat-message-streams'

export type { ChatStreamDocument, ChatStreamStatusValue as ChatStreamStatus }

export type ChatStreamCallback = (data: ChatStreamDocument | null) => void
export type ChatStreamErrorCallback = (error: Error) => void

export const getChatStreamRef = (db: Firestore, messageId: string): DocumentReference => {
  return doc(db, CHAT_STREAMS_COLLECTION, messageId)
}

export const subscribeToChatStream = (
  db: Firestore,
  messageId: string,
  onData: ChatStreamCallback,
  onError?: ChatStreamErrorCallback
): Unsubscribe => {
  const streamRef = getChatStreamRef(db, messageId)

  return onSnapshot(
    streamRef,
    (snapshot: DocumentSnapshot) => {
      if (snapshot.exists()) {
        onData(snapshot.data() as ChatStreamDocument)
      } else {
        onData(null)
      }
    },
    (error: Error) => {
      console.error('Chat stream subscription error:', error)
      onError?.(error)
    }
  )
}

export const deleteChatStream = async (db: Firestore, messageId: string): Promise<void> => {
  const streamRef = getChatStreamRef(db, messageId)
  await deleteDoc(streamRef)
}
